module.exports = __webpack_public_path__ + "static/media/group.28d6762a.svg";